<template>
  <div class="flexbox">
    <div class="line-box">
      <p>貸出可能数:</p>
      <div v-if="park.Corporation.code == 'DOCOMO'">
        <p><strong class="num">{{ park.AdditionalInformation.Availability.stockNum }}</strong>台</p>
      </div>
      <div v-else>
        <strong class="str">{{ stockLevel('stock') }}</strong>
      </div>
    </div>

    <div class="blank" />

    <div class="line-box">
      <p>返却可能数:</p>
      <div v-if="park.Corporation.code == 'DOCOMO'">
        <p v-if="park.AdditionalInformation.Availability.returnableUnlimited == 'true'"><strong>可</strong></p>
        <p v-else><strong>{{ park.AdditionalInformation.Availability.emptyNum }}</strong>台</p>
      </div>
      <div v-else>
        <strong class="str">{{ stockLevel('empty') }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DbsParkStockAndEmpty",
  props: {
    park: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const stockLevel = (perspective) => {
      const stockArr = ["なし", "残りわずか", "あり", "余裕あり", "余裕あり"]
      const emptyArr = ["返却可能", "返却可能", "返却可能", "残りわずか", "返却不可"]
      if (perspective == 'stock') {
        return stockArr[Number(props.park.AdditionalInformation.Availability.stockLevel)]
      } else {
        return emptyArr[Number(props.park.AdditionalInformation.Availability.stockLevel)]
      }
    }
    return {
      stockLevel
    };
  },
};
</script>

<style lang="scss" scoped>
.flexbox {
  display: flex;
  padding: 0 5% 3%;
  justify-content: center;
}

.flexbox .line-box {
  position: relative;
  width: 48%;
  max-width: 200px;
}

.flexbox .blank {
  width: 4%;
}

.flexbox .line-box>p {
  width: 100%;
  text-align: center;
  padding: 5% 0;
  border: 1px solid #d9d9d9;
  border-radius: 10px 10px 0 0;
}

.flexbox .line-box div {
  text-align: center;
  width: 100%;
  padding: 15px 0 10px;
  display: block;
  border: 1px solid #d9d9d9;
  border-radius: 0px 0px 10px 10px;
  border-top: 0;
}

.flexbox .line-box div strong {
  font-size: 1.5rem;
}
</style>
